/**
 * Represents the gender of a [[Member]].
 */
export var MemberGender;
(function (MemberGender) {
    /**
     * Not Specified
     *
     * @remarks
     * Known as `null` in Vista Loyalty.
     */
    MemberGender["NotSpecified"] = "NotSpecified";
    /**
     * Male
     */
    MemberGender["Male"] = "Male";
    /**
     * Female
     */
    MemberGender["Female"] = "Female";
    /**
     * Other, represents any non-binary gender.
     *
     * @remarks
     * Known as 'Unknown' in Vista Loyalty, but historically used to represent non-binary genders.
     */
    MemberGender["Other"] = "Other";
})(MemberGender || (MemberGender = {}));
//# sourceMappingURL=member-gender.js.map